{
  "Untitled event": "Evento sin título",
  "Under a minute": "Menos de un minuto",
  "{minutes} min": "{minutes} min",
  "{hours} h {minutes} min": "{hours} h {minutes} min",
  "{hours} h": "{hours} h",
  "Under 1 MB": "Menos de 1 MB",
  "{count} part": {
    "one": "{count} parte",
    "other": "{count} partes"
  },
  "{count} recording": {
    "one": "{count} grabación",
    "other": "{count} grabaciones"
  },
  "data file|Event details": "Detalles de los eventos",
  "Every event's title, date, place, link and settings": "Título, fecha, lugar, enlace y configuración de cada evento",
  "Guests and registrations": "Invitados y registros",
  "Names, emails, how each guest joined and what they watched": "Nombres, correos, cómo se unió cada invitado y qué vio",
  "Guestbook messages": "Mensajes del libro de visitas",
  "Every message with its event, name and time": "Cada mensaje con su evento, nombre y hora",
  "Viewer counts": "Número de espectadores",
  "Live and replay viewers for each recording": "Espectadores en vivo y de la grabación de cada evento",
  "Sales and donations": "Ventas y donaciones",
  "Tickets, paid downloads and donations, with amounts and dates": "Boletos, descargas pagadas y donaciones, con montos y fechas",
  "This recording belongs to another account.": "Esta grabación pertenece a otra cuenta.",
  "We couldn't find this recording. It may have been deleted.": "No encontramos esta grabación. Puede que se haya eliminado.",
  "Downloads are temporarily unavailable. Please try again in a few minutes.": "Las descargas no están disponibles por ahora. Inténtalo de nuevo en unos minutos.",
  "Could not reach EventLive. Check your internet connection and try again.": "No se pudo conectar con EventLive. Revisa tu conexión a internet e inténtalo de nuevo.",
  "Ready to download": "Lista para descargar",
  "{count} recording is being prepared": {
    "one": "Se está preparando {count} grabación",
    "other": "Se están preparando {count} grabaciones"
  },
  "Download this one when one of them is ready.": "Descarga esta cuando alguna de ellas esté lista.",
  "Could not load your recordings.": "No se pudieron cargar tus grabaciones.",
  "Couldn't download the file": "No se pudo descargar el archivo",
  "Still preparing. Long recordings take a while; you can leave this page and come back.": "Todavía se está preparando. Las grabaciones largas tardan un rato; puedes salir de esta página y volver más tarde.",
  "Joining {parts} parts into one MP4. This usually takes a few minutes.": "Uniendo {parts} partes en un solo MP4. Suele tardar unos minutos.",
  "Preparing the MP4. This usually takes a few minutes.": "Preparando el MP4. Suele tardar unos minutos.",
  "This is taking much longer than usual. Try again, or contact support.": "Está tardando mucho más de lo normal. Inténtalo de nuevo o contacta con soporte.",
  "Couldn't prepare the download. Try again.": "No se pudo preparar la descarga. Inténtalo de nuevo.",
  "In the Secure Archive, so it can't be downloaded. Restore it to download it again, or delete it.": "Está en el archivo seguro, así que no se puede descargar. Restáurala para volver a descargarla, o elimínala.",
  "In the Secure Archive, so it can't be downloaded. You can delete it.": "Está en el archivo seguro, así que no se puede descargar. Puedes eliminarla.",
  "Restore {title}": "Restaurar {title}",
  "Delete {title}": "Eliminar {title}",
  "Download": "Descargar",
  "Preparing…": "Preparando…",
  "Preparing {title}": "Preparando {title}",
  "Try again: {title}": "Intentar de nuevo: {title}",
  "Download {title}": "Descargar {title}",
  "Guestbook PDF · {count} message": {
    "one": "PDF del libro de visitas · {count} mensaje",
    "other": "PDF del libro de visitas · {count} mensajes"
  },
  "Download the guestbook of {title} as a PDF": "Descargar el libro de visitas de {title} en PDF",
  "Download {title} (CSV)": "Descargar {title} (CSV)",
  "Deleted": "Eliminado",
  "Couldn't delete it": "No se pudo eliminar",
  "Delete “{title}”?": "¿Eliminar “{title}”?",
  "The event, its recording, guest list and guestbook are deleted for good. This can't be undone.": "El evento, su grabación, la lista de invitados y el libro de visitas se eliminarán para siempre. No se puede deshacer.",
  "Delete event": "Eliminar evento",
  "Loading your recordings…": "Cargando tus grabaciones…",
  "one MP4 file each": "un archivo MP4 por grabación",
  "loading more…": "cargando más…",
  "Download everything": "Descargar todo",
  "Your recordings are yours. Download any of them, any time, free.": "Tus grabaciones son tuyas. Descarga cualquiera de ellas cuando quieras, gratis.",
  "Give a family or a couple their video, or keep your own archive.": "Entrega su video a una familia o a una pareja, o guarda tu propio archivo.",
  "Download everything is for business accounts. To download a video, open its event and choose Download & View Stats.": "Descargar todo es para cuentas de empresa. Para descargar un video, abre su evento y elige Descargar y ver estadísticas.",
  "Recordings": "Grabaciones",
  "Couldn't load your recordings": "No se pudieron cargar tus grabaciones",
  "No recordings yet": "Aún no hay grabaciones",
  "When you stream an event or upload a video, it shows up here, ready to download.": "Cuando transmites un evento o subes un video, aparece aquí, listo para descargar.",
  "Search for a recording": "Buscar una grabación",
  "Search recordings by title, place or date": "Buscar grabaciones por título, lugar o fecha",
  "Clear search": "Borrar búsqueda",
  "No recordings match “{query}”.": "Ninguna grabación coincide con “{query}”.",
  "Show {count} more": "Mostrar {count} más",
  "{count} recording found.": {
    "one": "Se encontró {count} grabación.",
    "other": "Se encontraron {count} grabaciones."
  },
  "Each MP4 joins every live session and upload in order, in the best quality we keep.": "Cada MP4 une en orden todas las sesiones en vivo y las subidas, con la mejor calidad que guardamos.",
  "Long recordings are big files, so use a fast connection.": "Las grabaciones largas son archivos grandes, así que usa una conexión rápida.",
  "It opens in your browser to save. Long recordings are big files: a computer on Wi-Fi is quickest.": "Se abre en tu navegador para guardarla. Las grabaciones largas son archivos grandes: lo más rápido es una computadora con Wi-Fi.",
  "Your data": "Tus datos",
  "Spreadsheets for Excel, Numbers or Google Sheets, covering every event in your account": "Hojas de cálculo para Excel, Numbers o Google Sheets con todos los eventos de tu cuenta",
  "One page with your events that anyone with the link can watch, and your ticketed events, newest first.": "Una página con tus eventos que cualquiera con el enlace puede ver y tus eventos con boletos, del más reciente al más antiguo.",
  "Your Video Wall link": "El enlace de tu muro de videos",
  "Video Wall link": "Enlace del muro de videos",
  "Copy Video Wall link": "Copiar enlace del muro de videos",
  "Open Video Wall": "Abrir muro de videos",
  "Embed on your website": "Embed en tu sitio web",
  "Paste the code into your website's HTML or embed block.": "Pega el código en el HTML de tu sitio web o en un bloque de inserción.",
  "Code type": "Tipo de código",
  "Script (recommended)": "Script (recomendado)",
  "The wall grows to fit all your events instead of scrolling inside a box.": "El muro crece para mostrar todos tus eventos en lugar de desplazarse dentro de un recuadro.",
  "Simple iframe (no script)": "Iframe simple (sin script)",
  "For site builders that remove scripts. The wall scrolls inside the space your page gives it.": "Para creadores de sitios web que quitan los scripts. El muro se desplaza dentro del espacio que le da tu página.",
  "Copy embed code": "Copiar el código",
  "Embed code copied": "Código copiado",
  "Paste it into your website's HTML.": "Pégalo en el HTML de tu sitio web."
}
